"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_RU_TRANS = {
    'time picker': 'Выбор Времени',
    'today': 'Сегодня',
    'set time': 'Установить Время',
    'close': 'Закрыть',
    'cancel': 'аннулировать',
    'confirm': 'Подтвердить',
    'hour': 'Час',
    'minute': 'Минута',
    'second': 'Секунда',
};
//# sourceMappingURL=ru.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ng-pick-datetime/locale/ru.js
// module id = ../../../../ng-pick-datetime/locale/ru.js
// module chunks = 15